
import {
  SET_NODES,
  SET_FROM_DATA,
  NAV_REQUEST_STARTED,
  NAV_REQUEST_FINISHED
} from '../actions/navbar';
const initialState = {
  nodes: [],
  from: {},
  loadingRequests: 0
};

function reducer(state = initialState, action = {}) {
  switch (action.type) {
    case SET_NODES:
      return {...state, nodes: action.nodes};
    case SET_FROM_DATA:
      return {...state, from: action.from};
    case NAV_REQUEST_STARTED:
      return {...state, loadingRequests: state.loadingRequests + 1};
    case NAV_REQUEST_FINISHED:
      return {...state, loadingRequests: Math.max(0, state.loadingRequests - 1)};
    default:
      return state;
  }
}

export default reducer;



// WEBPACK FOOTER //
// ./src/reducers/navbar.js